module.exports = __webpack_public_path__ + "static/media/boss-bar-red-10.f1fd4748.png";